import './Subiecte.css';

export default function Subiecte2021() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2021{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectAugust2021MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectAugust2021MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremAugust2021MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectAugust2021SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectAugust2021SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremAugust2021SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectIunie2021MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectIunie2021MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremIunie2021MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectIunie2021SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectIunie2021SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremIunie2021SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectSpeciala2021MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a></li>
                            <li><a href="/subiecte/2021/BaremSpeciala2021MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectSimulare2021MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectSimulare2021MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremSimulare2021MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectSimulare2021SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectSimulare2021SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremSimulare2021SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div><div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectModel2021MIC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectModel2021MIPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremModel2021MI.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2021/SubiectModel2021SNC.pdf" target="_blank" rel="noreferrer">Subiect C/C++</a>{" "} |{" "} <a href="/subiecte/2021/SubiectModel2021SNPascal.pdf" target="_blank" rel="noreferrer">Subiect Pascal</a></li>
                            <li><a href="/subiecte/2021/BaremModel2021SN.pdf" target="_blank" rel="noreferrer">Barem</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}